import { io } from 'socket.io-client';

const URL = process.env.NODE_ENV === 'production' && window.location.hostname !== 'localhost'
    ? undefined // In production it defaults to window.location
    : 'http://localhost:3000'; // For local dev against realtime-service directly

export const socket = io(URL, {
    path: '/socket.io/',
    reconnectionDelay: 1000,
    reconnection: true,
    reconnectionAttempts: 10,
    transports: ['websocket', 'polling'], // Fallback to polling is necessary behind some reverse proxies
});

socket.on('connect', () => {
    console.log('Real-time socket connected:', socket.id);
});

socket.on('disconnect', () => {
    console.log('Real-time socket disconnected');
});
